import React from "react"

import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import Image from "../../CustomImage";
import TrendsContent from "./TrendsContent";
import BreadcrumbItem from "../../BreadcrumbItem";
import { toTitleCase } from "../../../helpers/to-title-case";

const TrendsPage = (props) => {
  const { trendsData, slug, linkage } = props;

  return (
    <>
      <section className="hero-home dark-overlay mb-5">
        {trendsData.imagePath && (
          <Image
            src={`/content/${trendsData.imagePath}`}
            alt={trendsData.title}
            className="bg-image"
            loading="eager"
            fill
            priority={true}
          />
        )}
        <Container className="py-7">
          <div className="overlay-content text-center text-white">
            <h1 className="display-3 text-serif fw-bold text-shadow mb-0 h1 text-white">
              {trendsData.title}
            </h1>
          </div>
        </Container>
      </section>
      <section>
        <Container className="trends">
          <Row>
            <Col sm={8}>
              <Breadcrumb listProps={{ className: "pl-0  justify-content-start mb-5" }}>
                <BreadcrumbItem href="/">Home</BreadcrumbItem>
                <BreadcrumbItem href="/categories" >Categories</BreadcrumbItem>
                {slug[2] && (
                  <BreadcrumbItem href={`/companies/${slug[0]}`} >{toTitleCase(linkage.parent_label)}</BreadcrumbItem>
                )}
                {linkage.item ? (
                  <BreadcrumbItem href={linkage.base_url}>{toTitleCase(linkage.item.label)}</BreadcrumbItem>
                ) : (
                  <BreadcrumbItem href={linkage.base_url}>{toTitleCase(linkage.label)}</BreadcrumbItem>
                )}
                <BreadcrumbItem active>Trends & stats</BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
          <p className="mx-auto col-lg-10 col-xl-8 lead mb-5" dangerouslySetInnerHTML={{ __html: trendsData.intro }} />
          <TrendsContent content={trendsData.content} />
        </Container>
      </section>
    </>
  )
}

export default TrendsPage